import * as React from "react";
import { Clock, CloudSun, Thermometer, Wind, Droplets, MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
function LiveClock() {
  const [time, setTime] = React.useState(new Date());
  React.useEffect(() => {
    const timer = setInterval(() => {
      const hkTime = new Date(new Date().toLocaleString("en-US", {
        timeZone: "Asia/Hong_Kong"
      }));
      setTime(hkTime);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex flex-col items-center justify-center p-6 text-center">
      <div className="flex items-center gap-2 mb-4 text-secondary">
        <Clock className="w-5 h-5" />
        <span className="text-sm font-semibold uppercase tracking-widest">Hong Kong Time</span>
      </div>
      <div className="text-5xl md:text-6xl font-mono font-bold text-primary tracking-tighter">
        {time.toLocaleTimeString("en-HK", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      })}
      </div>
      <div className="mt-2 text-muted-foreground font-sans">
        {time.toLocaleDateString("en-HK", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      })}
      </div>
    </div>;
}
function HongKongWeather() {
  const weatherData = {
    temp: "28°C",
    condition: "Partly Cloudy",
    humidity: "72%",
    wind: "12 km/h",
    location: "Victoria Harbour"
  };
  return <div className="flex flex-col p-6">
      <div className="flex items-center gap-2 mb-6 text-secondary justify-center md:justify-start">
        <CloudSun className="w-5 h-5" />
        <span className="text-sm font-semibold uppercase tracking-widest">Current Weather</span>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col items-center md:items-start gap-1">
          <div className="flex items-center gap-2 text-primary">
            <Thermometer className="w-4 h-4" />
            <span className="text-xs font-medium uppercase">Temp</span>
          </div>
          <span className="text-2xl font-bold text-primary">{weatherData.temp}</span>
        </div>

        <div className="flex flex-col items-center md:items-start gap-1">
          <div className="flex items-center gap-2 text-primary">
            <Droplets className="w-4 h-4" />
            <span className="text-xs font-medium uppercase">Humidity</span>
          </div>
          <span className="text-2xl font-bold text-primary">{weatherData.humidity}</span>
        </div>

        <div className="flex flex-col items-center md:items-start gap-1">
          <div className="flex items-center gap-2 text-primary">
            <Wind className="w-4 h-4" />
            <span className="text-xs font-medium uppercase">Wind</span>
          </div>
          <span className="text-2xl font-bold text-primary">{weatherData.wind}</span>
        </div>

        <div className="flex flex-col items-center md:items-start gap-1">
          <div className="flex items-center gap-2 text-primary">
            <MapPin className="w-4 h-4" />
            <span className="text-xs font-medium uppercase">Station</span>
          </div>
          <span className="text-sm font-medium text-muted-foreground truncate w-full text-center md:text-left">
            {weatherData.location}
          </span>
        </div>
      </div>
    </div>;
}
export default function HongKongweathertimewidget() {
  return <section data-section-id="255484" id="hong-kongweathertimewidget" className="text-foreground py-16 md:py-24 overflow-hidden bg-muted light">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:text-left max-w-3xl">
          <h2 className="text-3xl md:text-4xl font-bold font-serif mb-4 text-primary">Hong Kong Live Status&nbsp;</h2>
          
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="bg-card/50 backdrop-blur-md border border-border rounded-2xl shadow-xl overflow-hidden">
            <CardContent className="p-0">
              <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-border">
                <div className="bg-secondary/5">
                  <LiveClock />
                </div>
                <div className="bg-background/40">
                  <HongKongWeather />
                </div>
              </div>
            </CardContent>
          </Card>
          
          <div className="mt-6 flex items-center justify-center gap-2 text-muted-foreground text-sm font-sans italic">
            <div className="w-2 h-2 rounded-lg bg-secondary animate-pulse" />
            Live updates from Hong Kong Observatory & HKT
          </div>
        </div>
      </div>
    </section>;
}